import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';


function ReportInner() {
    const location = useLocation();
    const navigate = useNavigate();
    const report = location.state?.report;

    if (!report) {
        return <p>No report data available</p>;
    }


    return (
        <div className='Reportinner'>
            <button className='Backbtn' onClick={() => navigate('/ViewReports')}>Back</button>
            <h1>Report Details</h1>
            <p className="content-text">You can see reports list from here</p>
            <div className="reportfullinfo">
                <p><strong>Title:</strong> {report.title + '#' + report.id}</p>
                <p><strong>Time:</strong> {report.time}</p>
                <p><strong>Type:</strong> {report.type}</p>
                <p><strong>File:</strong> <a href={report.file} target='_blank' style={{color: 'blue'}} download='download'>Download</a></p>
                <p><strong>Location:</strong> {report.abuseLocation}</p>
                <p><strong>Abuse Date:</strong> {report.abuseDate}</p>
                <p><strong>Awareness Date:</strong> {report.awarenessDate}</p>
                <p><strong>Name:</strong> {report.personName}</p>
                <p><strong>Function:</strong> {report.personFunction}</p>
                <p><strong>Organization:</strong> {report.personOrganization}</p>
                <p><strong>Description:</strong> {report.abuseDescription}</p>
            </div>


        </div>
    )
}

export default ReportInner